export const REDUCER_NAME = 'agencies';

export const AGENCY_TYPE = {
  STATE: 'state'
};
